import { render, staticRenderFns } from "./trainingModulePageNew2.vue?vue&type=template&id=476e3aaa&scoped=true&"
import script from "./trainingModulePageNew2.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew2.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew2.vue?vue&type=style&index=0&id=476e3aaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476e3aaa",
  null
  
)

export default component.exports